module.exports = __webpack_public_path__ + "static/media/img6.7f7ca3a2.jpg";